@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.tabs {
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: absolute;
  right: calc(100% + 4px);
  top: 50%;
  transform: translateY(-50%);
  padding: 10px 5px;
  background: var(--light-80);
  box-shadow: 1px 1px 0px 0px var(--light-90) inset, 0px 2px 12px 0px var(--dark-4);
  border-radius: 8px;
  @include blur(35px);
}

.tabGroup {
  display: flex;
  align-items: center;
  gap: 5px;

  [data-autopilot-system-redesign='on'] & {
    gap: 0;
  }
}

.tab {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  outline: none;
  gap: 4px;
  color: var(--dark-100);
  border-radius: 5px;
  min-width: 50px;
  padding: 10px 13px;

  [data-autopilot-system-redesign='on'] & {
    @include transition;
    border: 1px solid transparent;
  }

  &.compact {
    padding: 10px 5px;
  }

  &.hovered {
    background: var(--dark-20);
    box-shadow: 0 5px 10px 0 var(--light-5);

    [data-autopilot-system-redesign='on'] & {
      box-shadow: none;
    }
  }

  &.active,
  &.pressed {
    background: rgba(0, 0, 0, 0.08);
    @include pressed-shadow;

    [data-autopilot-system-redesign='on'] & {
      box-shadow: none;
      border-radius: 5px;
      border: 1px solid var(--dark-4);
      background: var(--dark-4);
    }
  }
}

[data-color-scheme='light'] {
  .tab {
    color: var(--dark-80);

    &.hovered {
      background: var(--dark-4);
    }
  }
}

.tabLabel {
  @include xs-sohne-medium;
  font-weight: 400;

  [data-autopilot-system-redesign='on'] & {
    @include xs-sohne-book;
    line-height: 135%;
  }
}

.tabDot {
  position: absolute;
  top: 3px;
  right: 5px;
  border-radius: 50%;
  background: var(--avatar);
  width: 10px;
  height: 10px;
  animation: pulse 1.5s infinite;
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.4);

  @keyframes pulse {
    0% {
      box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.4);
    }

    70% {
      box-shadow: 0 0 0 8px rgba(0, 0, 0, 0);
    }

    100% {
      box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
    }
  }
}

.tabPanel {
  width: var(--designer-right-rail-width);
  background: var(--light-80);
  box-shadow: 1px 1px 0px 0px var(--light-90) inset, 0px 2px 12px 0px var(--dark-4);
  border-radius: 8px;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 0;

  [data-autopilot-system-redesign='on'] & {
    box-shadow: none;
    border: 1px solid var(--dark-8);
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: -1;
    @include blur(35px);
  }

  &.hidden {
    display: none;
  }
}

[data-color-scheme='light'] {
  .tabPanel {
    background: var(--light-60);
  }
}

.panel {
  @include hide-scrollbar;
  position: relative;
  height: 100%;
  background: var(--light-80);
  border-radius: 8px;
  overflow: scroll;
  display: flex;
  flex-direction: column;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: -1;
    @include blur(35px);
  }
}

@media (min-width: $tabletPortraitMinWidth) {
  .tab {
    padding: 5px;
  }

  .tabPanel {
    width: unset;
  }
}

.separator {
  border-radius: 2px;
  background: var(--Dark-4, rgba(0, 0, 0, 0.04));
  width: 1px;
  height: 38px;
  margin: 5px;
}
